### global require, ga, _hmt ###

require 'plugins/pure/pure-min.css'
require 'plugins/icomoon/style.css'
require 'plugins/flexslider/flexslider.css'
require 'plugins/sweetalert/lib/sweet-alert.css'
require 'styles/common/util.scss'
require 'styles/common/common.scss'
require 'styles/pages/safe_pingan.scss'

require 'script!jquery'
require 'script!flexslider'
require '../common/form-validation.coffee'
require 'script!ajaxform'
require '../common/fast-nav.coffee'
sweetMeg = require '../common/city.coffee'

browser =
  isIE8: !!navigator.userAgent.match(/MSIE 8.0/)
  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)

###
# flexslider
###
$ ->
  $('.flexslider').flexslider {
    animation: 'slide'
    directionNav: false
  }

###
# countUp
###
do->
  fn = 1

  $(window).scroll ->
    cTop = $('.partner').offset().top
    scrollTop = $(this).scrollTop()
    if scrollTop >= cTop
      fn--
      countNum(fn) if fn >= 0

  countNum = (fn)->
    $yuyueVal = parseInt($('#yuyue').html())
    $finishVal = parseInt($('#finish').html())
    $npsVal = parseInt($('#nps').html())
    $offlineVal = parseInt($('#offline').html())

    options = {
      separator: ''
    }

    numAnim_yuyue = new CountUp("yuyue", 0, $yuyueVal, 0, 2.5, options)
    numAnim_finish = new CountUp("finish", 0, $finishVal, 0, 2.5, options)
    numAnim_nps = new CountUp("nps", 0, $npsVal, 0, 2.5, options)
    numAnim_offline = new CountUp("offline", 0, $offlineVal, 0, 2.5, options)
    numAnim_yuyue.start()
    numAnim_finish.start()
    numAnim_nps.start()
    numAnim_offline.start()

  ###
  # 顶部报名
  ###

  $form = $('#appointment form')
  $mobile = $form.find 'input[name="mobile"]'
  $btn = $form.find 'button[type="submit"]'

  browser =
    isIE8: !!navigator.userAgent.match(/MSIE 8.0/)
    isIE9: !!navigator.userAgent.match(/MSIE 9.0/)

  $mobile.on 'focus',->
    $me = $(this)
    $btn.addClass('hover')

  $mobile.on 'blur',->
    $me = $(this)
    $btn.removeClass('hover')

  $form.validate
    errorPlacement: (error,elem)->
      alert(error.html()) if browser.isIE8
      swal {
        type: 'error'
        title: error.html()
        allowOutsideClick: true
        confirmButtonText: '确定'
        confirmButtonColor: '#2F86F9'
      }
    submitHandler: (form)->
      if not browser.isIE8
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"
      $(form).ajaxSubmit
        dataType: 'json'
        error: ->
          alert('对不起！出错了,请稍后重试！') if browser.isIE8
          swal {
            type: 'error'
            title: '对不起！出错了,请稍后重试！'
            allowOutsideClick: true
            confirmButtonText: '确定'
            confirmButtonColor: '#2F86F9'
          }
        success: (res)->
          if res.status is 'success'
            swal {
              customClass: 'alert-success'
              title: '<img class="form_success" src="'+$('#alertImg').attr('src')+'" alt="">'
              confirmButtonText: '返  回'
              confirmButtonColor: '#3b9bff'
              allowOutsideClick: true
              html: true
            }
          else
            alert(res.msg[0].info) if browser.isIE8
            swal {
              type: 'error'
              title: res.msg[0].info
              allowOutsideClick: true
              confirmButtonText: '确定'
              confirmButtonColor: '#2F86F9'
            }
        complete: ->
          $btn.removeAttr 'disabled'

  $mobile.rules 'add',
    required: true
    mobileNum: true
    messages:
      required: '请输入手机号码'
      mobileNum: '请输入正确手机号码'



/** WEBPACK FOOTER **
 ** /root/workspace/jimujia-pc_4ez2/wwwroot/static/~/coffeelint-loader!./safe_pingan.coffee
 **/